<textarea   [value]="valueSubject | async"
            #textAreaRef
            ssFormInput
            [ngStyle]="{
              height:heightSubject | async,
              resize:(readOnlyObs | async) ? 'none' : null
            }"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="minRowsSubject | async"
            [cdkAutosizeMaxRows]="maxRowsSubject | async"
            matInput
            class="full-width"
            
></textarea>
